import { taskAPI } from '@/utils/api';

const cancelledTaskIds = new Set();

export function isVideoTaskCancelled(taskId) {
  if (taskId == null) return false;
  return cancelledTaskIds.has(String(taskId));
}

/**
 * 终止视频任务：与详情页一致，调用 POST /tasks/{id}/cancel-video。
 * Worker 会停止轮询并写入 CANCELED / USER_CANCEL；远端任务可能仍跑至自然结束。
 */
export async function cancelVideoTask(taskId) {
  if (taskId == null) return null;
  const id = String(taskId);
  cancelledTaskIds.add(id);
  try {
    const updated = await taskAPI.cancelVideo(id);
    return updated?.task || updated || null;
  } catch (e) {
    const msg = String(e?.message || e || '');
    // 已结束：视为幂等成功（历史「终止」与详情取消可重复点）
    if (/已结束|无法取消|CONFLICT|409/i.test(msg)) {
      return null;
    }
    cancelledTaskIds.delete(id);
    throw e;
  }
}

export function clearVideoTaskCancelled(taskId) {
  if (taskId == null) return;
  cancelledTaskIds.delete(String(taskId));
}
